module.exports = __webpack_public_path__ + "static/media/Ikemefula N. Nwachukwu.35b3bd42.png";